module.exports = __webpack_public_path__ + "img/shrinking-icon.07f2aff7.svg";